var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnderMaintenance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15364_3257)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15364_3257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H64V64H8V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15364_3257)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 20.6875C27.5431 20.6875 20.6875 27.5431 20.6875 36C20.6875 38.7932 21.4353 41.4117 22.7417 43.6661L27.1558 39.2595C25.5866 35.0336 27.2478 30.1699 31.2892 27.8405C34.6393 25.9098 38.6821 26.2638 41.6086 28.4176L34.1193 32.7342V37.084L37.8927 39.2589L45.3821 34.9423C45.7872 38.5493 44.0729 42.2217 40.7229 44.1526C38.1966 45.6086 35.2762 45.7652 32.7377 44.8307L28.3141 49.2468C30.573 50.5603 33.1987 51.3125 36 51.3125C44.4569 51.3125 51.3125 44.4569 51.3125 36C51.3125 27.5431 44.4569 20.6875 36 20.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 20.6875C27.5431 20.6875 20.6875 27.5431 20.6875 36C20.6875 38.7932 21.4353 41.4117 22.7417 43.6661L27.1558 39.2595C25.5866 35.0336 27.2478 30.1699 31.2892 27.8405C34.6393 25.9098 38.6821 26.2638 41.6086 28.4176L34.1193 32.7342V37.084L37.8927 39.2589L45.3821 34.9423C45.7872 38.5493 44.0729 42.2217 40.7229 44.1526C38.1966 45.6086 35.2762 45.7652 32.7377 44.8307L28.3141 49.2468C30.573 50.5603 33.1987 51.3125 36 51.3125C44.4569 51.3125 51.3125 44.4569 51.3125 36C51.3125 27.5431 44.4569 20.6875 36 20.6875Z",
    fill: "#B60202",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1454 55.0372C25.662 56.7398 28.535 57.9552 31.6284 58.5513L32.172 61.8126C32.2709 62.406 32.6641 62.9062 33.2656 62.9062H38.7345C39.336 62.9062 39.7294 62.406 39.8282 61.8126L40.3718 58.5513C43.4651 57.9552 46.3382 56.7398 48.8547 55.0372L51.5456 56.9591C52.0349 57.3088 52.6669 57.3845 53.0922 56.9591L56.9592 53.092C57.3846 52.6668 57.3089 52.0349 56.9592 51.5454L55.0373 48.8546C56.7396 46.3377 57.9553 43.4648 58.5515 40.3716L61.8127 39.828C62.4061 39.7291 62.9064 39.3358 62.9064 38.7344V33.2655C62.9064 32.6641 62.4061 32.2707 61.8127 32.1719L58.5515 31.6283C57.9553 28.535 56.7396 25.6622 55.0373 23.1453L56.9592 20.4545C57.3089 19.965 57.3846 19.3331 56.9592 18.9079L53.0922 15.0408C52.6669 14.6154 52.0349 14.6911 51.5456 15.0408L48.8547 16.9627C46.3382 15.2601 43.4651 14.0447 40.3718 13.4486L39.8282 10.1873C39.7294 9.59403 39.336 9.09364 38.7345 9.09364H33.2656C32.6641 9.09364 32.2709 9.59403 32.172 10.1873L31.6284 13.4486C28.535 14.0447 25.662 15.2601 23.1454 16.9627L20.4546 15.0408C19.9652 14.6911 19.3332 14.6154 18.908 15.0408L15.0409 18.9079C14.6155 19.3331 14.6913 19.965 15.0409 20.4545L16.9628 23.1453C15.2605 25.6622 14.0449 28.535 13.4487 31.6283L10.1874 32.1719C9.59414 32.2707 9.09375 32.6641 9.09375 33.2655V38.7344C9.09375 39.3358 9.59414 39.7291 10.1874 39.828L13.4487 40.3716C14.0449 43.4648 15.2605 46.3377 16.9628 48.8546",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1454 55.0372C25.662 56.7398 28.535 57.9552 31.6284 58.5513L32.172 61.8126C32.2709 62.406 32.6641 62.9062 33.2656 62.9062H38.7345C39.336 62.9062 39.7294 62.406 39.8282 61.8126L40.3718 58.5513C43.4651 57.9552 46.3382 56.7398 48.8547 55.0372L51.5456 56.9591C52.0349 57.3088 52.6669 57.3845 53.0922 56.9591L56.9592 53.092C57.3846 52.6668 57.3089 52.0349 56.9592 51.5454L55.0373 48.8546C56.7396 46.3377 57.9553 43.4648 58.5515 40.3716L61.8127 39.828C62.4061 39.7291 62.9064 39.3358 62.9064 38.7344V33.2655C62.9064 32.6641 62.4061 32.2707 61.8127 32.1719L58.5515 31.6283C57.9553 28.535 56.7396 25.6622 55.0373 23.1453L56.9592 20.4545C57.3089 19.965 57.3846 19.3331 56.9592 18.9079L53.0922 15.0408C52.6669 14.6154 52.0349 14.6911 51.5456 15.0408L48.8547 16.9627C46.3382 15.2601 43.4651 14.0447 40.3718 13.4486L39.8282 10.1873C39.7294 9.59403 39.336 9.09364 38.7345 9.09364H33.2656C32.6641 9.09364 32.2709 9.59403 32.172 10.1873L31.6284 13.4486C28.535 14.0447 25.662 15.2601 23.1454 16.9627L20.4546 15.0408C19.9652 14.6911 19.3332 14.6154 18.908 15.0408L15.0409 18.9079C14.6155 19.3331 14.6913 19.965 15.0409 20.4545L16.9628 23.1453C15.2605 25.6622 14.0449 28.535 13.4487 31.6283L10.1874 32.1719C9.59414 32.2707 9.09375 32.6641 9.09375 33.2655V38.7344C9.09375 39.3358 9.59414 39.7291 10.1874 39.828L13.4487 40.3716C14.0449 43.4648 15.2605 46.3377 16.9628 48.8546",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6314 62.9062L32.7377 44.8306C35.2763 45.7651 38.1967 45.6085 40.7229 44.1525C44.073 42.2216 45.7873 38.5492 45.3821 34.9422L37.8928 39.2588L34.1194 37.0839L34.1193 32.7341L41.6086 28.4175C38.6822 26.2637 34.6393 25.9097 31.2892 27.8404C27.2479 30.1698 25.5867 35.0335 27.1558 39.2594L9.09375 57.2909",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6314 62.9062L32.7377 44.8306C35.2763 45.7651 38.1967 45.6085 40.7229 44.1525C44.073 42.2216 45.7873 38.5492 45.3821 34.9422L37.8928 39.2588L34.1194 37.0839L34.1193 32.7341L41.6086 28.4175C38.6822 26.2637 34.6393 25.9097 31.2892 27.8404C27.2479 30.1698 25.5867 35.0335 27.1558 39.2594L9.09375 57.2909",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15364_3257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnderMaintenance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/underMaintenance.36133b4fbc393a1bc9962d090dec44b8.svg";